import React from 'react';

const Dash: React.FC = () => {
  return (
    <svg viewBox="0 0 13 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8051 3.16096L0.417969 3.16096L0.417969 0.838379L12.8051 0.83838L12.8051 3.16096Z"
      />
    </svg>
  );
};

export { Dash };
